import React, { useEffect, useMemo, useRef, useState } from 'react';
import { renderToNode, unmountFromNode } from '@virtidev/pet-detective-client';
import { useCurrentOrganisation } from '@core/helpers/useCurrentOrganisation';
import useFlashMessage from '@core/components/FlashMessage';
import { getVirtualHumanAPI } from '@base/utility/VirtualHumanUtility';
import { GetAccessToken } from '@base/utility/LoginUtility';
import useUser from '@core/helpers/useUser';

const VirtualCoachChat = ({ virtualHuman }) => {
  // Make a reference to the DOM node that the Virtual Human will be rendered into
  const domNode = useRef(null);

  useCurrentOrganisation(virtualHuman?.OrganisationID);
  const { addFlashMessage } = useFlashMessage();
  const accessToken = GetAccessToken();

  const { ID: userID, Name: userName, UserType: userType } = useUser();

  useEffect(() => {
    const options = {
      addFlashMessage,
      showHeader: false,
      path: `/embed/virtual-coach/${virtualHuman.ID}`,
      jwtToken: accessToken,
      isEmbeddedApp: true,
      virtualHumanAPI: virtualHuman.APIEndpoint || getVirtualHumanAPI(),
      virtualHumanData: virtualHuman,
      organisationID: Number(virtualHuman?.OrganisationID),
      userID: Number(userID),
      userName,
      featureFlags: [],
      userType,
    };
    const currentDomNode = domNode.current;
    renderToNode(currentDomNode, options);

    return () => {
      unmountFromNode(currentDomNode);
    };
  }, [accessToken, addFlashMessage, userID, userName, userType, virtualHuman]);

  return <div id="hello" ref={domNode} />;
};

export default VirtualCoachChat;
